            :read_only="read_only"
<template>
    <div>
        <commission-statement-ordered
            :closing="closing"
            :read_only="read_only"
        />

        <wire-instructions
            :closing="closing"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import CommissionStatementOrdered from './closing/commission-statement-ordered.vue';
import WireInstructions from './closing/wire-instructions.vue';

export default {
    components: {
        CommissionStatementOrdered,
        WireInstructions,
    },

    props: {
        closing: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
